import { CCol, CLabel, CRow, CCardHeader, CForm } from "@coreui/react";
import React, { useEffect } from "react";

const Test = () => {
  useEffect(() => {}, []);
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Test Page</h3>
          </CCol>
        </CRow>
        <hr />
        <CForm className="was-validation">
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom01"
                className="col-sm-12 col-form-label"
              >
                Hello Word
              </CLabel>
            </CCol>
          </CRow>
        </CForm>
      </CCardHeader>
    </>
  );
};
export default Test;
